export const money = (v: number | null | undefined, dp = 2): string =>
  v == null || !isFinite(v) ? '—' : `$${v.toFixed(dp)}`;

export const miles = (v: number | null | undefined): string =>
  v == null || !isFinite(v) ? '—' : `${v.toFixed(1)} mi`;

export const num = (v: number | null | undefined, dp = 0): string =>
  v == null || !isFinite(v) ? '—' : v.toFixed(dp);

// Hours since an ISO timestamp.
export function hoursSince(iso: string | null | undefined): number {
  if (!iso) return Infinity;
  const t = new Date(iso).getTime();
  if (!isFinite(t)) return Infinity;
  return (Date.now() - t) / 36e5;
}

// Staleness class for a price cell: '' | 'staleness-warn' (>48h) | 'staleness-danger' (>96h).
export function stalenessClass(iso: string | null | undefined): string {
  const h = hoursSince(iso);
  if (h > 96) return 'staleness-danger';
  if (h > 48) return 'staleness-warn';
  return '';
}

export const todayISO = (): string => new Date().toISOString().slice(0, 10);

// Inventory cell class: red when out (0), yellow when below the low threshold.
export function invClass(inv: number, lowThreshold: number): string {
  if (inv <= 0) return 'inv-out';
  if (inv < lowThreshold) return 'inv-low';
  return '';
}
